<script setup>
import VueApexCharts from "vue3-apexcharts";

const props = defineProps({
  series: Array,
  labels: Array,
  totalLabel: String
})

const chart = {
  series: props.series,
  colors: ["#1C64F2", "#16BDCA"],
  chart: {
    type: 'bar',
    height: 350,
    stacked: true,
    stackType: '100%',
    dataLabels: {
      enabled: false
    },
  },
  yaxis: {
    labels: {
    },
  },
  xaxis: {
    categories: props.labels,
  },
  plotOptions: {
    bar: {
      horizontal: true,
      columnWidth: "100%",
      borderRadiusApplication: "end",
      borderRadius: 6,
    },
  },
  fill: {
    opacity: 1
  },
  legend: {
    position: 'bottom',
  },
}
</script>

<template>
  <VueApexCharts :options="chart" :series="chart.series"></VueApexCharts>
</template>
